// extracted by mini-css-extract-plugin
export default {"greenButton":"PlasmicGreenButton_greenButton__1YhTj","text":"PlasmicGreenButton_text__LTcey"};